<template>
  <div>
    <hr />
    <div class="mb-3">
      <table class="tablaBusqueda">
        <tr>
          <td><label for="nombre" class="form-label">Nombre</label></td>
          <td>
            <input
              type="text"
              class="form-control"
              id="nombreBusqueda"
              name="nombreBusqueda"
              v-model="nombreBusqueda"
              style="width: 500px; text-transform: uppercase"
              required
            />
          </td>
          <td class="centro">
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="getDataPagina(1)"
              title="Buscar registros"
            >
              <i
                class="material-icons"
                style="font-size: 24px; color: blue; cursor: pointer"
                >search</i
              >
              Buscar
            </button>
          </td>
          <td class="centro">
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="getDataPaginaTodos(1)"
              title="Todos los registros"
            >
              <i
                class="material-icons"
                style="font-size: 24px; color: blue; cursor: pointer"
                >auto_awesome_motion</i
              >
            </button>
          </td>
          <td>
            <button
              type="submit"
              class="btn btn-light"
              data-bs-toggle="modal"
              data-bs-target="#ventanaModal"
              @click="abrirModalCrear"
              title="Nuevo registro"
            >
              <i
                class="material-icons"
                style="font-size: 24px; color: green; cursor: pointer"
                >add_box</i
              >
            </button>
          </td>
        </tr>
      </table>
    </div>
    <table id="sampleTable" class="table table-hover">
      <thead>
        <tr>
          <th scope="col">Código</th>
          <th scope="col">Nombre</th>
          <th scope="col">Opciones</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="elempres in datosPaginados"
          :key="elempres.idElemPres"
          @dblclick="handleRowClick($event, elempres.idElemPres)"
        >
          <td>{{ elempres.codigo }}</td>
          <td>{{ elempres.nombre }}</td>
          <td>
            <select
              class="form-select form-select-sm"
              @change="handleAction($event, elempres.idElemPres)"
            >
              <option disabled selected>Seleccione...</option>
              <option value="resumen">Editar</option>
              <option value="detalles">Elementos</option>
              <option value="borrar">Borrar</option>
            </select>
          </td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()">
          <a class="page-link" href="#">Anterior</a>
        </li>
        <li
          id="lugar"
          v-for="pagina in totalPaginas()"
          v-bind:key="pagina"
          v-on:click="getDataPagina(pagina)"
          class="page-item"
          v-bind:class="isActive(pagina)"
        >
          <a class="page-link" href="#">{{ pagina }}</a>
        </li>
        <li class="page-item" v-on:click="getNextPage()">
          <a class="page-link" href="#">Siguiente</a>
        </li>
      </ul>
    </nav>
    <!-- Modal -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title" id="exampleModalLabel">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form>
            <div class="modal-body">
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2">
                    <label for="idElemPres" class="form-label"
                      >IdElemPres</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="idElemPres"
                      name="idElemPres"
                      v-model="datoElemPres.idElemPres"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <!-- Botón Lista de Valores  Prestador -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idPrestador" class="form-label">
                      Prestador</label
                    >
                  </div>
                  <div class="col-10">
                    <select
                      class="form-control"
                      id="idPrestador"
                      name="idPrestador"
                      v-model="datoElemPres.idPrestador"
                    >
                      <option
                        v-for="prestador in prestadors"
                        :value="prestador.idPrestador"
                        :key="prestador.idPrestador"
                      >
                        {{ prestador.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- Botón Lista de Valores  Prestador -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="codigo" class="form-label">Codigo</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="codigo"
                      name="codigo"
                      v-model="datoElemPres.codigo"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="nombre" class="form-label">Nombre</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="nombre"
                      name="nombre"
                      v-model="datoElemPres.nombre"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="modal-footer">
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="guardarElemPres"
              v-if="btnCrear"
              title="Guardar"
            >
              <i
                class="material-icons"
                style="font-size: 32px; color: blue; cursor: pointer"
                >save</i
              >
            </button>
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="guardarEditElemPres"
              v-if="btnEditar"
              title="Actualizar"
            >
              <i
                class="material-icons"
                style="font-size: 32px; color: blue; cursor: pointer"
                >update</i
              >
            </button>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import api from "@/services/api";
import { validarForm } from "../../modules/validacionesForms.js";
import dateFormat from "../../modules/dateFormat.js";
import { format } from "date-fns";

import * as $ from "jquery";
window["$"] = $;
window["jQuery"] = $;
import swal from "sweetalert";
export default {
  props: {
    p_idEmpresa: {
      type: Number,
      required: true,
    },
  },
  components: {
  },
  data() {
    return {
      elempress: [],
      datoElemPres: {},
      nombreBusqueda: "",
      titulo: "",
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      prestadors: [],
      estiloImagen: {
        width: "200px",
        height: "200px",
      },
    };
  },
  computed: {
    formattedFechaReg() {
      const originalDate = new Date(this.datoAuto.fechaReg);
      return format(originalDate, "dd/MM/yyyy");
    },
  },

  mounted() {
    this.getDataPaginaTodos(this.paginaActual);
    this.fetchPrestadors();
  },
  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    handleRowClick(event, idElemPres) {
      if (
        event.target.tagName === "SELECT" ||
        event.target.tagName === "OPTION"
      ) {
        return;
      }
      this.abrirEditar(idElemPres);
    },
    handleAction(event, idElemPres) {
      const action = event.target.value;
      if (action === "resumen") {
        this.abrirModalEditar(idElemPres);
      } else if (action === "detalles") {
        this.abrirEditar(idElemPres);
      } else if (action === "borrar") {
        this.deleteElemPres(idElemPres);
      }

      event.target.value = "Seleccione...";
    },	
    totalPaginas() {
      return Math.ceil(this.elempress.length / this.elementosPorPagina);
    },
    getDataPagina(noPagina) {
      if (this.nombreBusqueda != "") {
        api.get("/vwelempress/nombre/" +
              this.nombreBusqueda
          )
          .then((response) => {
            this.elempress = response.data.reverse();
            this.paginaActual = noPagina;
            this.datosPaginados = [];
            let ini =
              noPagina * this.elementosPorPagina - this.elementosPorPagina;
            let fin = noPagina * this.elementosPorPagina;
            this.datosPaginados = this.elempress.slice(ini, fin);
          });
      }
    },
    getDataPaginaTodos(noPagina) {
      api.get("/vwelempress").then((response) => {
        this.elempress = response.data.reverse();
        this.paginaActual = noPagina;
        this.datosPaginados = [];
        let ini = noPagina * this.elementosPorPagina - this.elementosPorPagina;
        let fin = noPagina * this.elementosPorPagina;
        this.datosPaginados = this.elempress.slice(ini, fin);
      });
    },
    getPreviousPage() {
      if (this.paginaActual > 1) {
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage() {
      if (this.paginaActual < this.totalPaginas()) {
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina) {
      return noPagina == this.paginaActual ? "active" : "";
    },
    validarForm() {
      const requiredFields = ["idPrestador", "codigo", "nombre"];
      const requiredFieldsText = ["idPrestador", "codigo", "nombre"];
      return validarForm(this.datoElemPres, requiredFields, requiredFieldsText);
    },
    async guardarElemPres() {
      if (this.validarForm() === 1) {
        try {
          await api.post("/elempress",
            this.datoElemPres
          );
          $("#ventanaModal").modal("hide");
          swal("Correcto!", "ElemPres creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditElemPres() {
      if (this.validarForm() === 1) {
        try {
          await api.post("/elempress",
            this.datoElemPres
          );
          $("#ventanaModal").modal("hide");
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "ElemPres creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors);
          array.forEach((element) => swal(String(element)));
        }
      }
    },
    abrirModalCrear() {
      this.modalWindow = true;
      this.datoElemPres = {};
      this.titulo = "Crear ";
      this.btnCrear = true;
      this.btnEditar = false;
    },
    abrirModalEditar(idElemPres) {
      this.modalWindow = true;
      if (idElemPres != null) {
        api.get("/vwelempress/" + idElemPres)
          .then((resp) => {
            this.datoElemPres = resp.data;
          });
      }
      $("#ventanaModal").modal("show");
      this.titulo = "Editar ";
      this.btnCrear = false;
      this.btnEditar = true;
    },
    abrirEditar(idElemPres) {
      if (idElemPres != null) {
        this.$router.push("/elempres_elemequi/" + idElemPres);
      }
    },
    async deleteElemPres(idElemPres) {
      try {
        await api.delete("/elempress/" + idElemPres
        );
        this.getDataPagina(this.paginaActual);
      } catch (error) {
        alert("No se pudo eliminar");
      }
    },
fetchPrestadors() {
  api.get("/vwprestadors/idempresa/"+this.p_idEmpresa)
    .then((response) => {
      this.prestadors = response.data;
    })
    .catch((error) => {
      console.error("Error fetching prestadors:", error);
    });
},
  },
};
</script>
